import { PhoneField, PhoneFieldProps } from '@components/phone-field';

import { FormFieldProps, FormValidatorType } from './types';
import { useFormField } from './use-form-field';

export type FormPhoneFieldProps<T = unknown> = FormFieldProps<PhoneFieldProps, T>;

export function FormPhoneField<T>(props: FormPhoneFieldProps<T>) {
  const validators: FormValidatorType[] = ['phone', ...(props.validators ?? [])];
  const formFieldProps = useFormField({ ...props, validators });

  return <PhoneField {...props} {...formFieldProps} />;
}
